declare namespace $ {

	type $mol_image__uri_shm_hitalama_mbutton_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_view__sub_shm_hitalama_mbutton_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_mbutton extends $mol_check {
		Img( ): $mol_image
		Front( ): $mol_view
		checked_style( ): Record<string, any>
		sub( ): readonly(any)[]
		style( ): Record<string, any> & ReturnType< $mol_check['style'] > & ReturnType< $shm_hitalama_mbutton['checked_style'] >
	}
	
}

//# sourceMappingURL=mbutton.view.tree.d.ts.map